import {
  GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_TIME_SUBTITLE,
  GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE,
  GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE,
  GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE,
} from "../../../i18n/keysTranslations";

const GLOBAL_REPORT_TIME_CHART_COPY_BY_BREAKDOWN = {
  daily: {
    resultsTitle: GLOBAL_REPORT_STATS_DAILY_RESULTS_TITLE,
    timeSubtitle: GLOBAL_REPORT_STATS_TIME_SUBTITLE,
    impressionsCtrSubtitle: GLOBAL_REPORT_STATS_IMPRESSIONS_CTR_SUBTITLE,
  },
  weekly: {
    resultsTitle: GLOBAL_REPORT_STATS_WEEKLY_RESULTS_TITLE,
    timeSubtitle: GLOBAL_REPORT_STATS_WEEKLY_TIME_SUBTITLE,
    impressionsCtrSubtitle: GLOBAL_REPORT_STATS_WEEKLY_IMPRESSIONS_CTR_SUBTITLE,
  },
  monthly: {
    resultsTitle: GLOBAL_REPORT_STATS_MONTHLY_RESULTS_TITLE,
    timeSubtitle: GLOBAL_REPORT_STATS_MONTHLY_TIME_SUBTITLE,
    impressionsCtrSubtitle:
      GLOBAL_REPORT_STATS_MONTHLY_IMPRESSIONS_CTR_SUBTITLE,
  },
};

const DEFAULT_BREAKDOWN = "weekly";

/**
 * Resolves i18n keys for time-series chart titles/subtitles by report breakdown.
 */
const getGlobalReportTimeChartCopyKeys = ({
  breakdown = DEFAULT_BREAKDOWN,
} = {}) =>
  GLOBAL_REPORT_TIME_CHART_COPY_BY_BREAKDOWN[breakdown] ||
  GLOBAL_REPORT_TIME_CHART_COPY_BY_BREAKDOWN[DEFAULT_BREAKDOWN];

export default getGlobalReportTimeChartCopyKeys;
